(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("classnames"), require("@material/floating-label/dist/mdc.floatingLabel.js"));else if (typeof define === 'function' && define.amd) define(["react", "classnames", "@material/floating-label/dist/mdc.floatingLabel.js"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("classnames"), require("@material/floating-label/dist/mdc.floatingLabel.js")) : factory(root["react"], root["classnames"], root["@material/floating-label/dist/mdc.floatingLabel.js"]);

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_32__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 31);
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      0:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
        /***/
      },

      /***/
      1:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
        /***/
      },

      /***/
      31:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict"; // The MIT License
        //
        // Copyright (c) 2018 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var __extends = this && this.__extends || function () {
          var _extendStatics = function extendStatics(d, b) {
            _extendStatics = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) {
                if (b.hasOwnProperty(p)) d[p] = b[p];
              }
            };

            return _extendStatics(d, b);
          };

          return function (d, b) {
            _extendStatics(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = this && this.__rest || function (s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          }
          return t;
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var React = __webpack_require__(0);

        var classnames = __webpack_require__(1); // @ts-ignore no mdc .d.ts


        var mdc_floatingLabel_1 = __webpack_require__(32);

        ;
        ;

        var FloatingLabel =
        /** @class */
        function (_super) {
          __extends(FloatingLabel, _super);

          function FloatingLabel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.labelElement_ = React.createRef();
            _this.state = {
              classList: new Set()
            };

            _this.initializeFoundation = function () {
              _this.foundation_ = new mdc_floatingLabel_1.MDCFloatingLabelFoundation(_this.adapter);

              _this.foundation_.init();
            }; // must be called via ref


            _this.shake = function () {
              _this.foundation_.shake(true);
            };

            _this.removeClassFromClassList = function (className) {
              var classList = _this.state.classList;
              classList.delete(className);

              _this.setState({
                classList: classList
              });
            };

            _this.handleWidthChange = function () {
              var handleWidthChange = _this.props.handleWidthChange;

              if (handleWidthChange && _this.labelElement_.current) {
                handleWidthChange(_this.labelElement_.current.offsetWidth);
              }
            };

            _this.onShakeEnd = function () {
              var LABEL_SHAKE = mdc_floatingLabel_1.MDCFloatingLabelFoundation.cssClasses.LABEL_SHAKE;

              _this.removeClassFromClassList(LABEL_SHAKE);
            };

            return _this;
          }

          FloatingLabel.prototype.componentDidMount = function () {
            this.initializeFoundation();
            this.handleWidthChange();

            if (this.props.float) {
              this.foundation_.float(true);
            }
          };

          FloatingLabel.prototype.componentWillUnmount = function () {
            this.foundation_.destroy();
          };

          FloatingLabel.prototype.componentDidUpdate = function (prevProps) {
            if (this.props.children !== prevProps.children) {
              this.handleWidthChange();
            }

            if (this.props.float !== prevProps.float) {
              this.foundation_.float(this.props.float);
            }
          };

          Object.defineProperty(FloatingLabel.prototype, "classes", {
            get: function get() {
              var classList = this.state.classList;
              var className = this.props.className;
              return classnames('mdc-floating-label', Array.from(classList), className);
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(FloatingLabel.prototype, "adapter", {
            get: function get() {
              var _this = this;

              return {
                addClass: function addClass(className) {
                  return _this.setState({
                    classList: _this.state.classList.add(className)
                  });
                },
                removeClass: this.removeClassFromClassList
              };
            },
            enumerable: true,
            configurable: true
          });

          FloatingLabel.prototype.render = function () {
            var _a = this.props,
                className = _a.className,
                // eslint-disable-line no-unused-vars
            children = _a.children,
                handleWidthChange = _a.handleWidthChange,
                // eslint-disable-line no-unused-vars
            float = _a.float,
                // eslint-disable-line no-unused-vars
            otherProps = __rest(_a, ["className", "children", "handleWidthChange", "float"]);

            return React.createElement("label", __assign({
              className: this.classes,
              ref: this.labelElement_,
              onAnimationEnd: this.onShakeEnd
            }, otherProps), children);
          };

          FloatingLabel.defaultProps = {
            className: '',
            float: false
          };
          return FloatingLabel;
        }(React.Component);

        exports.default = FloatingLabel;
        /***/
      },

      /***/
      32:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_32__;
        /***/
      }
      /******/

    })
  );
});